module.exports = __webpack_public_path__ + "img/icon-3-02.1fc08320.png";